__turbopack_context__.v({
  "activities": "vIQzMq_activities",
  "modal__gallery": "vIQzMq_modal__gallery",
});
